import { PagedSearch } from '../../shared/model/index';

export class MessageQueueSearch extends PagedSearch {
  public DateAndTimeToSendAfter: Date = null;
  public DateAndTimeToSendBefore: Date = null;
  public DateCreatedAfter: Date = null;
  public DateCreatedBefore: Date = null;
  public MessageSent: boolean = null;
  public Recurring: boolean = null;
  public Scheduled: boolean = null;
  public Subject: string = null;
  public SendFrom: string = null;
  public DateAndTimeToSend: Date = null;
  public DateCreated: Date = null;
  public CronSummary: string = null;
  public Count: number = null;
  public EndDate: Date = null;
  public TimeZoneOffsetMinutes: number = null;
  public UpcomingSendDate: Date = null;
  public LastMessageQueueCreatedOn = null;
  public LastMessageSentOn: Date = null;
}
